import React from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

const AnimationHeader = (props) => {
  const { children, duration = 1, delay = 0 } = props

  return (
    <motion.div
      style={{ transformOrigin: 'top' }}
      transition={{
        duration,
        delay,
        ease: [0.79, 0.14, 0.15, 0.86],
      }}
      initial={{ y: '-100%' }}
      animate={{ y: '0%' }}
      exit={{
        y: '-100%',
        transition: {
          duration: 0.7,
        },
      }}
      className="sectionAnimation bg-isabelline"
    >
      {children ? children : null}
    </motion.div>
  )
}

AnimationHeader.propTypes = {
  children: PropTypes.any,
  duration: PropTypes.number,
  delay: PropTypes.number,
}

export default AnimationHeader
